<template>
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        App Name - {{sheetTitle}}        
      </h1>
      <ol class="breadcrumb">
        <li><a href="/messages-dashboard"><i class="fa fa-dashboard"></i> Home</a></li>
        <li class="active">App Messages Rows</li>
      </ol>
    </section>
    
    <!-- Main content -->
    <section class="content">
      <div class="row">
        <div class="col-xs-12 col-md-12 col-lg-12">
          <div class="box box-default">
            <!-- <div class="box-header with-border">
              <h3 class="box-title">App Name - {{sheetTitle}}</h3>
            </div> -->
            <!--<div class="loader" v-if="loading">
              <img src="/static/assets/loader/nivi-loader.svg" />
            </div> -->
            <div class="box-body" v-if="!loading">
              <div class="col-xs-12 col-lg-12">  
                <div class="appsDiv">
                  <all-rows :allRows="allRows" />
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <!-- /.row -->
    </section>
    <BlockUI v-if="loading"><i class="fa fa-cog fa-spin fa-3x fa-fw"></i><br/>Please wait...</BlockUI>
    <!-- /.content -->
  </div>
</template>

<script>
  import api from '../../../utils/api'
  import allRows from './allRows'
  export default {
    components: {
      'all-rows': allRows
    },
    methods: {
      getDataFromGoogleSheetByTitle (sheetTitle, sheetReference) {
        console.log('inside getDataFromGoogleSheetByTitle function')
        this.loading = true
        // this.config['stages'] = this.stages
        api.buildRequest('getDataFromGoogleSheetByTitle', 'POST', {sheetTitle: sheetTitle, sheetReference: sheetReference})
            .then(response => {
              this.loading = false
              if (response.status === 200) {
                this.allRows = response.data.payload.data
                console.log(this.allRows)
              } else {
                console.log('something went wrong')
              }
            }).catch(({ response }) => {
              this.loading = false
              this.$swal({
                type: 'error',
                text: response ? response.data.payload.message : 'An error occurred'
              })
            })
      }
    },
    computed: {
      isStages () {
        return Object.keys(this.allRows).length
      }
    },
    data () {
      return {
        allRows: {},
        sheetTitle: '',
        loading: true
      }
    },
    mounted () {
      // retrieve the configuration from mongodb
      if (this.$route.query.sheetTitle) {
        this.sheetTitle = this.$route.query.sheetTitle
        this.getDataFromGoogleSheetByTitle(this.$route.query.sheetTitle, this.$route.query.sheetReference)
        // this.getAllmessageFromMongo(this.$route.query.sheetTitle, this.$route.query.sheetReference)
      }
    }
  }
</script>

<style>
  .value {
    font-weight: bold;
  }
  .box-body {
    min-height: calc(100vh - 171px);
  }
  .form-loader img {
    width: 30px;
    height: 30px;
  }
  .action-button {
    clear: both;
    display: flex;
    justify-content: center;
  }
  .appsDiv {
    width: 100%;
    height: 100%;
    left: 50%;
    transform: translateX(0%);
  }
</style>



// WEBPACK FOOTER //
// addOrUpdate.vue?1f357b49